@if (feedbackMode.isActive) {
  <div class="feedback-mode-overlay">
    <div class="feedback-mode-banner">
      <span i18n="@@feedback.mode.instruction">Click on a concept or term section to send feedback about it, or </span>
      <a href="javascript:void(0)" (click)="sendGeneralFeedback($event)"
         i18n="@@feedback.mode.general">send general feedback</a>.
      <mat-icon class="feedback-mode-close" (click)="cancelFeedbackMode()"
                matTooltip="Cancel feedback" i18n-matTooltip="@@feedback.mode.cancel">close
      </mat-icon>
    </div>
  </div>
}
